var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isTable
    ? _c(
        "figure",
        {
          staticClass: "cog-table cog-section",
          class: [
            "cog-col",
            _vm.colNumClass,
            {
              "is-error": _vm.showValidation,
              "cog-table-bands": !_vm.chameleon && _vm.$source.readonly,
              "is-read-only": _vm.$source.readonly,
              ["cog-field--" + _vm.fieldIndex]: _vm.fieldIndex,
              "cog-force-shown": _vm.forceShown,
              "show-remove-button": _vm.showRemoveButton,
              "hide-remove-button": !_vm.showRemoveButton
            }
          ],
          attrs: {
            tabindex: _vm.showValidation || _vm.showLengthError ? 0 : -1
          },
          on: { click: _vm.triggerErrors, keyup: _vm.triggerErrors }
        },
        [
          _vm.showLabel || _vm.showHelptext
            ? _c(
                "figcaption",
                [
                  _vm.showLabel
                    ? _c(
                        "h" + Math.min(_vm.depth + 1, 4),
                        { tag: "h2", staticClass: "cog-heading" },
                        [
                          _vm._v(
                            "\n\t\t\t" + _vm._s(_vm.$source.label) + "\n\t\t\t"
                          ),
                          _vm.showValidation || _vm.showLengthError
                            ? _c("span", { staticClass: "cog-offscreen" }, [
                                _vm._v(", " + _vm._s(_vm.errorMessage))
                              ])
                            : _vm._e()
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showHelptext
                    ? _c("div", {
                        staticClass: "cog-helptext cog-html",
                        domProps: { innerHTML: _vm._s(_vm.$source.helptext) }
                      })
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "table",
            { class: { "is-compact": _vm.isCompact } },
            [
              _c(
                "colgroup",
                [
                  !_vm.$source.readonly
                    ? _c("col", { staticClass: "cog-table__delete-column" })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._l(_vm.$columns, function(column) {
                    return _c("col", {
                      key: column.name,
                      class: { "cog-table__hidden-col": !column.visible },
                      style: { width: column.width * 100 + "%" }
                    })
                  }),
                  _vm._v(" "),
                  _vm.paddingCols
                    ? _c("col", {
                        class: "cog-col cog-col--" + _vm.paddingCols
                      })
                    : _vm._e()
                ],
                2
              ),
              _vm._v(" "),
              _c("thead", [
                _c(
                  "tr",
                  [
                    !_vm.$source.readonly ? _c("th") : _vm._e(),
                    _vm._v(" "),
                    _vm._l(_vm.$columns, function(column) {
                      return _c(
                        "th",
                        {
                          key: column.name,
                          class: {
                            "is-required": column.property.required === true,
                            "cog-right": column.align === "right",
                            "cog-table__hidden-col": !column.visible
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "cog-label",
                              class: {
                                "cog-offscreen":
                                  (column.hideLabel ||
                                    !_vm
                                      .getPropertyLabel(column.property)
                                      .trim().length) &&
                                  !_vm.forceShowHeaders
                              }
                            },
                            [
                              _vm._v(
                                "\n\t\t\t\t\t\t" +
                                  _vm._s(
                                    _vm._f("breakWords")(
                                      _vm.getPropertyLabel(column.property)
                                    )
                                  )
                              ),
                              _vm.showAsterisk(column)
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "cog-asterisk",
                                      attrs: { "aria-hidden": "true" }
                                    },
                                    [_vm._v("*")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.showAsterisk(column) && !_vm.showValidation
                                ? _c("span", { staticClass: "cog-offscreen" }, [
                                    _vm._v(
                                      "(" +
                                        _vm._s(
                                          _vm.$resource("required-asterisk")
                                        ) +
                                        ")"
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              column.property.required === true &&
                              _vm.showValidation
                                ? _c("span", { staticClass: "cog-offscreen" }, [
                                    _vm._v(
                                      "(" +
                                        _vm._s(
                                          _vm
                                            .$resource("required")
                                            .replace(
                                              "{property}",
                                              _vm.getPropertyLabel(
                                                column.property
                                              )
                                            )
                                        ) +
                                        ")"
                                    )
                                  ])
                                : _vm._e()
                            ]
                          )
                        ]
                      )
                    })
                  ],
                  2
                )
              ]),
              _vm._v(" "),
              _c(
                "transition-group",
                {
                  tag: "tbody",
                  attrs: { name: "el-zoom-in-top" },
                  on: {
                    "after-leave": function($event) {
                      _vm.isAtMax = false
                    }
                  }
                },
                _vm._l(_vm.$source.items, function($item, index) {
                  return _c(
                    "vm-source",
                    {
                      key: $item.value.meta.id,
                      ref: "tableRow",
                      refInFor: true,
                      attrs: { source: $item }
                    },
                    [
                      _c(
                        "tr",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !$item.isHidden,
                              expression: "!$item.isHidden"
                            }
                          ],
                          class: $item.class
                        },
                        [
                          !_vm.$source.readonly
                            ? _c(
                                "td",
                                [
                                  _c(
                                    "transition",
                                    { attrs: { appear: "", name: "cog-fade" } },
                                    [
                                      _vm.showRemoveButton
                                        ? _c(
                                            "c-button",
                                            {
                                              staticClass: "cog-table__remove",
                                              attrs: {
                                                "no-style": "",
                                                title: _vm.getRemoveButtonText(
                                                  _vm.itemLabel,
                                                  $item.value.ItemNumber
                                                )
                                              },
                                              on: {
                                                click: e =>
                                                  _vm.removeItem(e, index)
                                              }
                                            },
                                            [_c("i-ex")],
                                            1
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm._t("default", null, {
                            item: $item.value,
                            adapter: $item,
                            isTable: true,
                            cols: _vm.cols,
                            generateCustomClass: _vm.generateCustomClass
                          })
                        ],
                        2
                      )
                    ]
                  )
                }),
                1
              ),
              _vm._v(" "),
              _vm.anyColumnsHaveSummary
                ? _c("tfoot", { staticClass: "cog-table__summary" }, [
                    _c(
                      "tr",
                      [
                        !_vm.$source.readonly ? _c("td") : _vm._e(),
                        _vm._v(" "),
                        _vm._l(_vm.$columns, function(column) {
                          return _c(
                            "td",
                            {
                              key: column.name,
                              class: {
                                "cog-right": column.summaryAlign === "right"
                              }
                            },
                            [
                              column.visible && column.summary
                                ? _c("div", [
                                    column.summaryLabel
                                      ? _c("strong", [
                                          _vm._v(
                                            _vm._s(column.summaryLabel) + ": "
                                          )
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(_vm.getColumnSummary(column))
                                      )
                                    ])
                                  ])
                                : _vm._e()
                            ]
                          )
                        })
                      ],
                      2
                    )
                  ])
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "cog-table__button-container" },
            [
              _c(
                "visible-transition",
                [
                  _vm.showAddButton
                    ? _c(
                        "c-button",
                        {
                          staticClass: "cog-button--secondary cog-table__add",
                          class: {
                            "cog-button--no-text":
                              _vm.getAddButtonText(_vm.itemLabel) === ""
                          },
                          attrs: {
                            title:
                              _vm.getAddButtonText(_vm.itemLabel) === ""
                                ? _vm.getGeneratedAddButtonText(_vm.itemLabel)
                                : null
                          },
                          on: { click: _vm.addItem },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "icon",
                                fn: function() {
                                  return [_c("i-plus")]
                                },
                                proxy: true
                              }
                            ],
                            null,
                            false,
                            4092991805
                          )
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t" +
                              _vm._s(_vm.getAddButtonText(_vm.itemLabel)) +
                              "\n\t\t\t\t"
                          )
                        ]
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("transition", { attrs: { name: "cog-error-message" } }, [
            _vm.showValidation || _vm.showLengthError
              ? _c(
                  "div",
                  {
                    staticClass:
                      "cog-error-message cog-error-message--container-footer pt-1",
                    attrs: { "aria-live": _vm.showLabel ? null : "polite" }
                  },
                  [_vm._v(_vm._s(_vm.errorMessage))]
                )
              : _vm._e()
          ])
        ],
        1
      )
    : _c("c-repeating-section", {
        ref: "repeatingSection",
        staticClass: "cog-table--repeating-section",
        attrs: {
          "hide-label": _vm.hideLabel,
          source: _vm.$source,
          "item-label": _vm.itemLabel,
          "add-button-text": _vm.addButtonText,
          "hide-add-remove-buttons": _vm.hideAddRemoveButtons,
          min: _vm.min,
          max: _vm.max,
          cols: _vm.cols,
          "override-depth": _vm.depth
        },
        scopedSlots: _vm._u(
          [
            {
              key: "readonly-item-header",
              fn: function({ item }) {
                return [_vm._t("readonly-item-header", null, { item: item })]
              }
            },
            {
              key: "default",
              fn: function({ item: item, adapter: $item }) {
                return [
                  _c(
                    "c-row",
                    [
                      _vm._t("default", null, {
                        item: item,
                        adapter: $item,
                        isTable: false,
                        cols: _vm.cols,
                        generateCustomClass: _vm.generateCustomClass
                      })
                    ],
                    2
                  )
                ]
              }
            },
            _vm.anyColumnsHaveSummary
              ? {
                  key: "footer",
                  fn: function() {
                    return [
                      _c("div", { staticClass: "cog-row" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "cog-table__summary--responsive cog-col cog-col--24"
                          },
                          _vm._l(
                            _vm.$columns.filter(c => c.visible && c.summary),
                            function(column, i) {
                              return _c(
                                "div",
                                {
                                  key: column.name,
                                  staticClass:
                                    "cog-table__summary-item--responsive"
                                },
                                [
                                  _c(
                                    "h" + Math.min(_vm.depth + 3, 4),
                                    {
                                      tag: "h4",
                                      staticClass: "cog-heading",
                                      attrs: {
                                        id: `cog-${_vm.$source.id}-summary-${i}`
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.getPropertyLabel(column.property)
                                        )
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      attrs: {
                                        "aria-labelledby": `cog-${_vm.$source.id}-summary-${i}`
                                      }
                                    },
                                    [
                                      column.summaryLabel
                                        ? _c("span", [
                                            _vm._v(
                                              _vm._s(column.summaryLabel) + ": "
                                            )
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.getColumnSummary(column) || "—"
                                          )
                                        )
                                      ])
                                    ]
                                  )
                                ],
                                1
                              )
                            }
                          ),
                          0
                        )
                      ])
                    ]
                  },
                  proxy: true
                }
              : null
          ],
          null,
          true
        )
      })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }